import { KYMW5002Component } from './kymw5002.component';
import { KYMW5002OutputModel } from './vo/kymw5002-output.model';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { GetImageListModel } from './vo/get-image-list.model';
import { GetImageInfoDetailModel } from './vo/get-image-info-detail.model';
import { GetUseRecordListModel } from './vo/get-use-record-list.model';
import { GetUseRecordImageListModel } from './vo/get-use-record-image-list.model';
import { KYMW0B00OutputModel } from '../../kymw0b/kymw0b00/vo/kymw0b00-output.model';
import { GetSearchImageListModel } from './vo/get-search-image-list.model';
import { UseImageInfoModel } from './vo/use-image-info.model';
import { KYMW5002ImageInfoDetailBoxComponent } from './kymw5002-image-info-detail-box/kymw5002-image-info-detail-box.component';
import { CommonSetting } from '../../kymw00/common-setting';
import { SelectCoopInfoModel } from './vo/select-coop-info.model';
import { KYMW0B00InputModel } from '../../kymw0b/kymw0b00/vo/kymw0b00-input.model';
import { KYMW0C00InputModel } from '../../kymw0c/kymw0c00/vo/kymw0c00-input.model';
import { KYMW0E00InputModel } from '../../kymw0e/kymw0e00/vo/kymw0e00-input.model';
import { Menu } from '@grapecity/wijmo.input';

/**
 * EC使用画像指示画面の値を管理するクラス
 *
 * @export KYMW5002Model
 * @class KYMW5002Model
 */
export class KYMW5002Model {

  public kymw5002Component: KYMW5002Component;

  /*-----------------------------------------------------------------------------------------------
		Bindable変数
		-----------------------------------------------------------------------------------------------*/
  /* ヘッダー部 */
  public pcode = String('');

  public guideGoodsName = String('');

  public guideStandardName = String('');

  public textCaption = String('');
  /* 使用画像部 */
  public useImageList: Array<any> = [];

  /* 検索結果部 */
  public goodsImageList: Array<any> = [];      // 「商品画像タブ」の画像一覧用

  public pcodeList: Array<any> = [];           // Ｐコードコンボ用

  public pcodeInfoList: Array<any> = [];       // 選択したＰコードに対応した企画情報一覧用

  public useHistoryImageList: Array<any> = []; // 選択したＰコード、受注コードでの「使用履歴タブ」の画像一覧用

  public searchImageList: Array<any> = [];     // 「検索画像タブ」の画像一覧用

  /* 画像情報詳細 */
  public goodsImagePreviewURL = String('');
  public goodsImagePreviewPath = String('');
  public goodsImageFilePath = String('');
  public textCaptionImageId = String('');

  public flag: boolean = <boolean>false;

  /*-----------------------------------------------------------------------------------------------
  情報変数
  -----------------------------------------------------------------------------------------------*/
  // InputVO
  public inputFlg = String('');					// 呼び出し元フラグ
  public inputOrderCode = String('');				// 受注コード
  public inputPcode = String('');					// Ｐコード
  public inputPushCoopCode = String('');			// 呼び出し元生協コード
  public inputGoodsName = String('');				// 商品名
  public inputGoodsStandardName = String('');		// 規格名

  public inputEnableCoopCode: Array<any> = [];		// チェック可能生協コード
  public inputSelectCoopCode: Array<any> = [];		// 選択生協コード

  // 抽出結果
  public selectedImageData: any = null;			// 選択されたイメージID
  public tempSelectedImageData: any = null;		// 仮選択イメージID
  public imageInfoDetailChangeFlg: boolean;		// 画像詳細情報変更フラグ

  // 履歴情報
  public startOrderCodeBefore = String('');
  public endOrderCodeBefore = String('');

  public readonly IMAGE_LIST_COUNT: number = Number(1000); 	// 画像検索結果最大表示数
  public maxUseImageCount = Number(1);             	// 使用画像の最大選択数

  public selectedImageExistFlg = true;
  public editMode = true;


  // 画面表示バインディング
  public allCoop = Boolean(false);
  public ibaraki = Boolean(false);
  public tochigi = Boolean(false);
  public gunma = Boolean(false);
  public chiba = Boolean(false);
  public saitama = Boolean(false);
  public tokyo = Boolean(false);
  public nagano = Boolean(false);
  public niigata = Boolean(false);
  public kuruco = Boolean(false);

  /** 選択された生協コードリスト */
  public selectedCoopList: Array<any> = [];

  /*-----------------------------------------------------------------------------------------------
  バインド情報更新
  -----------------------------------------------------------------------------------------------*/
  /**
   * 画像情報更新
   *
   * @param goodsImageList:Object
   */
  public updateImageList(data: any): void {
    if (data != null && !PlessViewUtilsSub.isEmptyArray(data)) {
      this.goodsImageList = data;
      this.kymw5002Component.vw_SearchResult.goodsImageCnt = this.goodsImageList.length;
    }
    if (!PlessViewUtilsSub.isEmptyArray(data.PcodeList)) {
      this.pcodeList = data.PcodeList;
    }

    if (!PlessViewUtilsSub.isEmpty(this.pcode)) {
      this.kymw5002Component.vw_SearchResult.tab_SearchResult.selectedIndex = 0;
    }
  }

  /**
  * 画像詳細情報VBOX取得
  *
  * @memberof KYMW5002Model
  */
  public get imageInfoDetailBox(): KYMW5002ImageInfoDetailBoxComponent {
    return this.kymw5002Component.vw_ImageInfoDetail.imageInfoDetailBox;
  }

  /**
   * 画像詳細情報更新
   *
   * @param data:Object
   */
  public updateImageInfoDetail(data: any): void {
    this.imageInfoDetailBox.clear();

    let endOrderCode2 = Number(0);
    if (data.EndOrderCode === '9999999') {
      endOrderCode2 = 1;
      data.EndOrderCode = '';
    } else if (String(data.StartOrderCode) === String(data.EndOrderCode)) {
      endOrderCode2 = 2;
    }

    this.imageInfoDetailBox.txi_StartOrderCode.setOrderCode(data.StartOrderCode);
    this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode(data.EndOrderCode);
    this.imageInfoDetailBox.endOrderCode2 = endOrderCode2.toString();
    this.imageInfoDetailBox.imageName = data.ImageName;
    this.imageInfoDetailBox.imageFileName = data.ImageFileName;
    this.imageInfoDetailBox.imageBelongName = this.getCodeValueName(data.ImageBelongId, data.ImageBelongName);
    this.imageInfoDetailBox.imageKindName = this.getCodeValueName(data.ImageKind, data.ImageKindName);
    this.imageInfoDetailBox.imageTypeName = this.getCodeValueName(data.ImageType, data.ImageTypeName);
    this.imageInfoDetailBox.cmb_ProcessInstruct.setCodeValue(data.ProcessInstruct);
    this.imageInfoDetailBox.remarks = data.Remarks;
    this.imageInfoDetailBox.cookingExPublish = PlessViewUtilsSub.StringTOBoolean(data.CookingExPublish);
    this.imageInfoDetailBox.txi_Priority.text = data.Priority;
    this.imageInfoDetailBox.pcode = data.Pcode;
    this.imageInfoDetailBox.guideGoodsName = data.GuideGoodsName;
    this.imageInfoDetailBox.guideStandardName = data.GuideStandardName;
    this.imageInfoDetailBox.cmb_CookingDiv.setCodeValue(data.CookingDiv);
    this.imageInfoDetailBox.cookingName = data.CookingName;
    this.imageInfoDetailBox.materialName = data.MaterialName;
    this.imageInfoDetailBox.keyWord = data.KeyWord;
    this.imageInfoDetailBox.cmb_EventId.setCodeValue(data.EventId);
    this.imageInfoDetailBox.cmb_PhotoContentsDiv.setCodeValue(data.PhotoContentsDiv);
    this.imageInfoDetailBox.photoInstructContents = data.PhotoInstructContents;
    this.imageInfoDetailBox.photoSchedule =
      PlessViewUtilsSub.editDate(PlessViewUtilsSub.nullToBlank(data.PhotoSchedule), '2');
    this.imageInfoDetailBox.cmb_PhotoStudioId.setStudioId(data.PhotoStudioId);
    this.imageInfoDetailBox.imageInstructDate = data.ImageInstructDate;
    this.imageInfoDetailBox.fileRegistDate = data.FileRegistDate;
    this.imageInfoDetailBox.jpgUpdateDate = data.JpgUpdateDate;
    this.imageInfoDetailBox.caption = data.TextCaption;

    this.goodsImagePreviewURL = data.ImagePreviewUrl;

    this.goodsImagePreviewPath = data.ImagePreviewPath;
    this.goodsImageFilePath = data.ImageFilePath;
    this.startOrderCodeBefore = data.StartOrderCode;
    this.endOrderCodeBefore = data.EndOrderCode;

    this.procViewEnable();
  }

  /**
   * 使用履歴・Ｐコード情報リスト情報更新
   */
  public updatePcodeInfoList(data: any): void {
    this.pcodeInfoList = [];
    if (data != null && !PlessViewUtilsSub.isEmptyArray(data)) {
      this.pcodeInfoList = data;
    }
  }

  /**
   * 使用履歴・画像リスト情報更新
   */
  public updateUseHistoryImageList(data: any): void {
    this.useHistoryImageList = [];
    if (data != null && !PlessViewUtilsSub.isEmptyArray(data)) {
      this.useHistoryImageList = data;
      this.kymw5002Component.vw_SearchResult.useHitoryImageCnt = this.useHistoryImageList.length;
    }
  }

  /**
   * 使用履歴・検索画像画像リスト情報更新
   */
  public updateSearchImageList(data: any): void {
    if (data != null && !PlessViewUtilsSub.isEmptyArray(data)) {
      let imageCnt = Number(0);
      if (data.length > this.IMAGE_LIST_COUNT) {
        this.kymw5002Component.dialogServiceSub.openAlertGetMessage('I0102', ['1000', '1000']);

        const searchImage1000List: Array<any> = [];

        // 表示最大値ほど加工して表示
        for (let cnt = Number(0); cnt < data.length; cnt++) {
          if (cnt === this.IMAGE_LIST_COUNT) {
            imageCnt = cnt;
            break;
          }
          searchImage1000List.push(data[cnt]);
        }

        this.searchImageList = searchImage1000List;
      } else {
        this.searchImageList = [];
        this.searchImageList = data;
        imageCnt = data.length;
      }

      this.kymw5002Component.vw_SearchResult.searchImageCnt = imageCnt;

    } else {
      this.kymw5002Component.dialogServiceSub.openAlertGetMessage('E0100');
    }
  }

  /**
   * UseImageList情報の画像キャプション更新
   */
  public updateTextCaption(textCaption: string): void {
    for (let i = Number(0); i < this.useImageList.length; i++) {
      if (this.useImageList[i].ImageId === this.textCaptionImageId) {
        this.useImageList[i].TextCaption = textCaption;
        return;
      }
    }
  }

  /*-----------------------------------------------------------------------------------------------
  VO Getter
  -----------------------------------------------------------------------------------------------*/
  /**
   * GetImageListVOを取得する
   */
  public getGetImageListVO(): GetImageListModel {
    const vo: GetImageListModel = new GetImageListModel();
    vo.pcode = this.pcode;
    vo.orderCode = this.inputOrderCode;
    return vo;
  }

  /**
   * GetImageInfoDetailVOを返却する
   *
   * @return GetImageInfoDetailVO
   */
  public getGetImageInfoDetailVO(): GetImageInfoDetailModel {
    const vo: GetImageInfoDetailModel = new GetImageInfoDetailModel();
    vo.imageId = this.selectedImageData.ImageId;
    return vo;
  }

  /**
   * GetUseRecordListVOを返却する
   *
   * @return GetUseRecordListVO
   */
  public getGetUseRecordListVO(): GetUseRecordListModel {
    const vo: GetUseRecordListModel = new GetUseRecordListModel();
    vo.coopCode = this.inputPushCoopCode;
    vo.pcode = this.kymw5002Component.vw_SearchResult.pCode;
    vo.thisOrderCode = this.inputOrderCode;
    return vo;
  }

  /**
   * GetUseRecordImageListVOを返却する
   *
   * @return GetUseRecordImageListVO
   */
  public getGetUseRecordImageListVO(): GetUseRecordImageListModel {
    const vo: GetUseRecordImageListModel = new GetUseRecordImageListModel();
    vo.orderCode = this.kymw5002Component.vw_SearchResult.dgv_PcodeInfoList.selectedItems[0].OrderCode;
    vo.mediumType = this.kymw5002Component.vw_SearchResult.dgv_PcodeInfoList.selectedItems[0].MediumType;
    vo.coopCode = this.inputPushCoopCode;
    vo.pcode = this.kymw5002Component.vw_SearchResult.pCode;
    vo.thisOrderCode = this.inputOrderCode;
    return vo;
  }

  /**
   * GetSearchImageListVOを返却する
   *
   * @return GetSearchImageListVO
   */
  public getGetSearchImageListVO(outputVO: KYMW0B00OutputModel): GetSearchImageListModel {
    const vo: GetSearchImageListModel = new GetSearchImageListModel();
    vo.pcodeList = PlessViewUtilsSub.nullToBlank(outputVO.pcodeList);
    // 商品案内用商品名
    vo.guideGoodsName = PlessViewUtilsSub.nullToBlank(outputVO.guideGoodsName);
    // 商品案内用規格名
    vo.guideStandardName = PlessViewUtilsSub.nullToBlank(outputVO.guideStandardName);
    vo.imageName = PlessViewUtilsSub.nullToBlank(outputVO.imageName);
    vo.imageFileName = PlessViewUtilsSub.nullToBlank(outputVO.imageFileName);
    vo.imageBelongId = PlessViewUtilsSub.nullToBlank(outputVO.imageBelongID);
    vo.imageKind = PlessViewUtilsSub.nullToBlank(outputVO.imageKind);
    vo.imageType = PlessViewUtilsSub.nullToBlank(outputVO.imageType);
    vo.processInstruct = PlessViewUtilsSub.nullToBlank(outputVO.processInstruct);
    vo.remarksList = PlessViewUtilsSub.nullToBlank(outputVO.remarks);

    if (PlessViewUtilsSub.nullToBlank(outputVO.cookingExPublish) === '1') {
      vo.cookingExPublish = '1';
    } else {
      vo.cookingExPublish = '';
    }

    vo.cookingDiv = PlessViewUtilsSub.nullToBlank(outputVO.cookingDiv);
    vo.cookingNameList = PlessViewUtilsSub.nullToBlank(outputVO.cookingName);
    vo.materialNameList = PlessViewUtilsSub.nullToBlank(outputVO.materialName);
    vo.keyWordList = PlessViewUtilsSub.nullToBlank(outputVO.keyWord);
    vo.eventId = PlessViewUtilsSub.nullToBlank(outputVO.eventID);
    vo.photoContentsDiv = PlessViewUtilsSub.nullToBlank(outputVO.photoContentsDiv);
    vo.photoStudioId = PlessViewUtilsSub.nullToBlank(outputVO.photoStudioID);
    vo.imageInstructUserId = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructUser);
    vo.imageInstructDateFrom = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructDateStart);
    vo.imageInstructDateTo = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructDateEnd);
    vo.fileRegistDateFrom = PlessViewUtilsSub.nullToBlank(outputVO.fileRegistDateStart);
    vo.fileRegistDateTo = PlessViewUtilsSub.nullToBlank(outputVO.fileRegistDateEnd);
    vo.status = PlessViewUtilsSub.nullToBlank(outputVO.status);
    vo.imageInstructDiv = PlessViewUtilsSub.nullToBlank(outputVO.imageInstrucrDiv);
    vo.imageEnabledDiv = PlessViewUtilsSub.nullToBlank(outputVO.imageEnableDiv);
    vo.thisOrderCode = this.inputOrderCode;
    vo.photoScheduleFrom = PlessViewUtilsSub.nullToBlank(outputVO.photoScheduleStart);
    vo.photoScheduleTo = PlessViewUtilsSub.nullToBlank(outputVO.photoScheduleEnd);
    vo.classCode = PlessViewUtilsSub.nullToBlank(outputVO.classCode);
    vo.multipleCode = outputVO.multipleCode;
    vo.startOrderCode = PlessViewUtilsSub.nullToBlank(outputVO.startOrderCode);
    vo.startDelivCatalogId = PlessViewUtilsSub.nullToBlank(outputVO.startDelivCatalogId);
    vo.billingName = PlessViewUtilsSub.nullToBlank(outputVO.billingName);
    vo.buyerCode = PlessViewUtilsSub.nullToBlank(outputVO.buyerCode);
    vo.outputFlg = PlessViewUtilsSub.nullToBlank(outputVO.outputFlg);
    vo.carriedForward = outputVO.carriedForward;
    vo.c2pfTarget = outputVO.c2pfTarget;
    vo.photographingChangeSchedule = outputVO.photographingChangeSchedule;
    return vo;
  }

  // アプトプットＶＯを返却する
  public getKymw5002OutputVO(): KYMW5002OutputModel {
    const imageList: Array<any> = [];

    if (!PlessViewUtilsSub.isEmptyArray(this.useImageList)) {
      for (let i = Number(0); i < this.useImageList.length; i++) {
        const vo: UseImageInfoModel = new UseImageInfoModel();

        vo.ImageFileName = this.useImageList[i].ImageFileName;
        vo.ImageId = this.useImageList[i].ImageId;
        vo.ImageName = this.useImageList[i].ImageName;
        vo.ImageURL = this.useImageList[i].ImageURL;
        vo.ShowSeq = this.useImageList[i].ShowSeq;
        vo.StartOrderCode = this.useImageList[i].StartOrderCode;
        vo.TextCaption = this.useImageList[i].TextCaption;
        vo.CookingExPublish = this.useImageList[i].CookingExPublish ?? '';
        imageList.push(vo);

        if (this.inputFlg === '2' || this.inputFlg === '3') {
          const fileExt: string = imageList[i].ImageURL.substr(imageList[i].ImageURL.length - 3, 3).toUpperCase();
          if (fileExt === CommonSetting.getVal('ImagePreviewExt').toUpperCase()
            || fileExt === CommonSetting.getVal('ImageFileExt').toUpperCase()) {
            imageList[i].ImageURL = imageList[i].ImageURL.substring(0, imageList[i].ImageURL.length - 4)
              + CommonSetting.getVal('ImageFileSmall') + '.' + CommonSetting.getVal('ImageCWSExt');
          }
        }
        imageList[i].ShowSeq = (i + 1).toString();
      }
    }

    const outputVO: KYMW5002OutputModel = new KYMW5002OutputModel();

    outputVO.useImageInfoVOList = imageList;
    outputVO.selectCoopInfoVOList = this.setCoopList();

    return outputVO;
  }

  public setCoopList(): Array<any> {
    const coopList: Array<any> = [];

    if (this.ibaraki) {
      const coopVO = new SelectCoopInfoModel();
      coopVO.selectCoopCode = this.kymw5002Component.kymw00Model.COOP_CODE_IB;
      coopList.push(coopVO);
    }

    if (this.tochigi) {
      const coopVO = new SelectCoopInfoModel();
      coopVO.selectCoopCode = this.kymw5002Component.kymw00Model.COOP_CODE_TO;
      coopList.push(coopVO);
    }

    if (this.gunma) {
      const coopVO = new SelectCoopInfoModel();
      coopVO.selectCoopCode = this.kymw5002Component.kymw00Model.COOP_CODE_GU;
      coopList.push(coopVO);
    }

    if (this.chiba) {
      const coopVO = new SelectCoopInfoModel();
      coopVO.selectCoopCode = this.kymw5002Component.kymw00Model.COOP_CODE_TI;
      coopList.push(coopVO);
    }

    if (this.saitama) {
      const coopVO = new SelectCoopInfoModel();
      coopVO.selectCoopCode = this.kymw5002Component.kymw00Model.COOP_CODE_SA;
      coopList.push(coopVO);
    }

    if (this.tokyo) {
      const coopVO = new SelectCoopInfoModel();
      coopVO.selectCoopCode = this.kymw5002Component.kymw00Model.COOP_CODE_TK;
      coopList.push(coopVO);
    }

    if (this.nagano) {
      const coopVO = new SelectCoopInfoModel();
      coopVO.selectCoopCode = this.kymw5002Component.kymw00Model.COOP_CODE_NA;
      coopList.push(coopVO);
    }

    if (this.niigata) {
      const coopVO = new SelectCoopInfoModel();
      coopVO.selectCoopCode = this.kymw5002Component.kymw00Model.COOP_CODE_NI;
      coopList.push(coopVO);
    }

    if (this.kuruco) {
      const coopVO = new SelectCoopInfoModel();
      coopVO.selectCoopCode = this.kymw5002Component.kymw00Model.COOP_CODE_KU;
      coopList.push(coopVO);
    }

    return coopList;
  }

  /**
   * KYMW0B00InputVOを返却する
   *
   * @return KYMW0B00InputVO
   */
  public getKYMW0B00InputVO(): KYMW0B00InputModel {
    const vo: KYMW0B00InputModel = new KYMW0B00InputModel();
    vo.processDiv = '3';
    return vo;
  }

  /**
   * KYMW0C00InputVOを返却する
   *
   * @return KYMW0C00InputVO
   */
  public getKYMW0C00InputVO(): KYMW0C00InputModel {
    const vo: KYMW0C00InputModel = new KYMW0C00InputModel();
    return vo;
  }

  /**
   * KYMW0E00InputVOを返却する
   *
   * @return KYMW0E00InputVO
   */
  public getKYMW0E00InputVO(processDiv: number): KYMW0E00InputModel {
    const vo: KYMW0E00InputModel = new KYMW0E00InputModel();
    vo.formID = 'KYMW5002';
    vo.processDiv = processDiv;
    vo.imageID = this.selectedImageData.ImageId;
    vo.imageName = this.selectedImageData.ImageName;
    vo.imageFileName = this.selectedImageData.ImageFileName;
    vo.startOrderCodeBefore = this.startOrderCodeBefore;
    vo.endOrderCodeBefore = this.endOrderCodeBefore;
    vo.startOrderCodeAfter = this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode;
    vo.endOrderCodeAfter = this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode;

    return vo;
  }

  /*-----------------------------------------------------------------------------------------------
  Util
  -----------------------------------------------------------------------------------------------*/
  /**
   * 【使用画像】選択されたイメージIndexを取得する
   */
  public getUseImageListSelectedImageIndex(): number {
    return this.getSelectedImageIndex(this.useImageList);
  }

  /**
   * 【検索結果：商品画像】選択されたイメージIndexを取得する
   */
  public getGoodsImageListSelectedImageIndex(): number {
    return this.getSelectedImageIndex(this.goodsImageList);
  }

  /**
   * 【検索結果：使用履歴】選択されたイメージIndexを取得する
   */
  public getUseHistoryImageListSelectedImageIndex(): number {
    return this.getSelectedImageIndex(this.useHistoryImageList);
  }

  /**
   * 【検索結果：検索画像】選択されたイメージIndexを取得する
   */
  public getSearchImageListSelectedImageIndex(): number {
    return this.getSelectedImageIndex(this.searchImageList);
  }

  /**
   * 選択されたイメージIndexを返却する
   *
   * @param imageList:ArrayCollection
   **/
  private getSelectedImageIndex(imageList: Array<any>): number {
    if (this.selectedImageData != null) {
      for (let i = Number(0); i < imageList.length; i++) {
        if (imageList[i].ImageId === this.selectedImageData.ImageId) {
          return i;
        }
      }
    }
    return -1;
  }

  /**
   * 選択された使用画像をリストから削除する
   */
  public deleteSelectedUseImage(): void {
    this.useImageList.splice(this.getSelectedImageIndex(this.useImageList), 1);

  }

  /**
   * 選択された使用画像を前へ移動する
   **/
  public moveFrontSelectedUseImage(): void {
    const selectedImageIndex: number = this.getSelectedImageIndex(this.useImageList);
    this.useImageList.splice(selectedImageIndex - 1, 0, this.useImageList[selectedImageIndex]);
    this.useImageList.splice(selectedImageIndex + 1, 1);
  }

  /**
   * 選択された使用画像を後ろへ移動する
   *
   **/
  public moveNextSelectedUseImage(): void {
    const selectedImageIndex: number = this.getSelectedImageIndex(this.useImageList);
    this.useImageList.splice(selectedImageIndex + 2, 0, this.useImageList[selectedImageIndex]);
    this.useImageList.splice(selectedImageIndex, 1);
  }

  /**
   * 選択された使用画像を先頭へ移動する
   *
   **/
  public moveFirstSelectedUseImage(): void {
    const selectedImageIndex: number = this.getSelectedImageIndex(this.useImageList);
    this.useImageList.splice(0, 0, this.useImageList[selectedImageIndex]);
    this.useImageList.splice(selectedImageIndex + 1, 1);
  }

  /**
   * 選択された使用画像を最後へ移動する
   *
   **/
  public moveLastSelectedUseImage(): void {
    const selectedImageIndex: number = this.getSelectedImageIndex(this.useImageList);
    this.useImageList.push(this.useImageList[selectedImageIndex]);
    this.useImageList.splice(selectedImageIndex, 1);
  }

  /**
   * 商品画像で選択した画像を使用画像に移動する
   *
   */
  public moveSelectedGoodsImageToUseImage(): void {
    const vo: UseImageInfoModel = new UseImageInfoModel();
    vo.ImageFileName = this.goodsImageList[this.getSelectedImageIndex(this.goodsImageList)].ImageFileName;
    vo.ImageId = this.goodsImageList[this.getSelectedImageIndex(this.goodsImageList)].ImageId;
    vo.ImageName = this.goodsImageList[this.getSelectedImageIndex(this.goodsImageList)].ImageName;
    vo.ImageURL = this.goodsImageList[this.getSelectedImageIndex(this.goodsImageList)].ImageURL;
    vo.ShowSeq = this.goodsImageList[this.getSelectedImageIndex(this.goodsImageList)].ShowSeq;
    vo.StartOrderCode = this.goodsImageList[this.getSelectedImageIndex(this.goodsImageList)].StartOrderCode;
    vo.CookingExPublish = this.goodsImageList[this.getSelectedImageIndex(this.goodsImageList)].CookingExPublish;

    this.useImageList.push(vo);
  }

  /**
   * 使用履歴で選択した画像を使用画像に移動する
   *
   */
  public moveSelectedUseHistoryImageToUseImage(): void {
    const vo: UseImageInfoModel = new UseImageInfoModel();
    vo.ImageFileName = this.useHistoryImageList[this.getSelectedImageIndex(this.useHistoryImageList)].ImageFileName;
    vo.ImageId = this.useHistoryImageList[this.getSelectedImageIndex(this.useHistoryImageList)].ImageId;
    vo.ImageName = this.useHistoryImageList[this.getSelectedImageIndex(this.useHistoryImageList)].ImageName;
    vo.ImageURL = this.useHistoryImageList[this.getSelectedImageIndex(this.useHistoryImageList)].ImageURL;
    vo.ShowSeq = this.useHistoryImageList[this.getSelectedImageIndex(this.useHistoryImageList)].ShowSeq;
    vo.StartOrderCode = this.useHistoryImageList[this.getSelectedImageIndex(this.useHistoryImageList)].StartOrderCode;
    vo.CookingExPublish = this.useHistoryImageList[this.getSelectedImageIndex(this.useHistoryImageList)].CookingExPublish;

    this.useImageList.push(vo);
  }

  /**
   * 検索画像で選択した画像を使用画像に移動する
   *
   */
  public moveSelectedSearchImageToUseImage(): void {
    const vo: UseImageInfoModel = new UseImageInfoModel();
    vo.ImageFileName = this.searchImageList[this.getSelectedImageIndex(this.searchImageList)].ImageFileName;
    vo.ImageId = this.searchImageList[this.getSelectedImageIndex(this.searchImageList)].ImageId;
    vo.ImageName = this.searchImageList[this.getSelectedImageIndex(this.searchImageList)].ImageName;
    vo.ImageURL = this.searchImageList[this.getSelectedImageIndex(this.searchImageList)].ImageURL;
    vo.ShowSeq = this.searchImageList[this.getSelectedImageIndex(this.searchImageList)].ShowSeq;
    vo.StartOrderCode = this.searchImageList[this.getSelectedImageIndex(this.searchImageList)].StartOrderCode;
    vo.CookingExPublish = this.searchImageList[this.getSelectedImageIndex(this.searchImageList)].CookingExPublish;

    this.useImageList.push(vo);
  }

  /**
   * クリア処理を行う
   */
  public clear(): void {
    this.pcode = '';
    this.guideGoodsName = '';
    this.guideStandardName = '';
    this.useImageList = [];
    this.goodsImageList = [];
    this.pcodeList = [];
    this.pcodeInfoList = [];
    this.useHistoryImageList = [];
    this.searchImageList = [];
    this.goodsImagePreviewURL = '';
    this.goodsImagePreviewPath = '';
    this.goodsImageFilePath = '';
    this.imageInfoDetailBox.clear();
    this.selectedImageData = null;
    this.tempSelectedImageData = null;
    this.imageInfoDetailChangeFlg = false;
    this.startOrderCodeBefore = '';
    this.endOrderCodeBefore = '';
    this.imageInfoDetailChangeFlg = false;
  }

  /**
   * 画面活性化・非活性化処理を行う
   */
  public procViewEnable(): void {
    // 選択コマ商品情報存在チェック
    const pcodeSetFlg = !PlessViewUtilsSub.isEmpty(this.pcode);
    this.kymw5002Component.vw_SearchResult.tab_SearchResult.tabs[0].isDisabled = !pcodeSetFlg;
    this.kymw5002Component.vw_SearchResult.tab_SearchResult.tabs[1].isDisabled = !pcodeSetFlg;

    if (!pcodeSetFlg) {
      this.kymw5002Component.vw_SearchResult.tab_SearchResult.selectedIndex = 2;
    }

    // 選択イメージ存在チェック
    const imageSetFlg: boolean = this.editMode && this.selectedImageData != null;
    this.kymw5002Component.plessEnabled(this.kymw5002Component.btn_Setting, imageSetFlg);

    if (imageSetFlg) {
      this.kymw5002Component.bindStartOrderCodeTextInputSelectedOrderCode(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode);
      this.kymw5002Component.bindEndOrderCodeComboBox(Number(this.imageInfoDetailBox.endOrderCode2));
    }

    // 画像情報詳細をすべて非活性
    // this.imageInfoDetailBox.disabledFlag = true;
    this.imageInfoDetailBox.txi_StartOrderCode.disabled = true;
    this.imageInfoDetailBox.txi_EndOrderCode1.disabled = true;
    this.imageInfoDetailBox.cmb_EndOrderCode2.nativeElement.disabled = true;
    this.imageInfoDetailBox.cmb_ProcessInstruct.disabled = true;
    this.imageInfoDetailBox.txi_Remarks.disabled = true;
    this.imageInfoDetailBox.ckb_CookingExPublish.nativeElement.disabled = true;
    this.imageInfoDetailBox.txi_Priority.disabled = true;
    this.imageInfoDetailBox.cmb_CookingDiv.disabled = true;
    this.imageInfoDetailBox.txi_CookingName.disabled = true;
    this.imageInfoDetailBox.txi_MaterialName.disabled = true;
    this.imageInfoDetailBox.txi_KeyWord.disabled = true;
    this.imageInfoDetailBox.cmb_EventId.disabled = true;
    this.imageInfoDetailBox.cmb_PhotoContentsDiv.disabled = true;
    this.imageInfoDetailBox.txi_PhotoInstructContents.disabled = true;
    this.imageInfoDetailBox.dfd_PhotoSchedule.isDisabled = true;
    this.imageInfoDetailBox.cmb_PhotoStudioId.disabled = true;
    this.imageInfoDetailBox.txi_Caption.disabled = true;

    this.kymw5002Component.plessEnabled(this.kymw5002Component.btn_Setting, true);

    this.updateContextMenuEnabled();
  }

  /**
   * 使用画像リストにImageIdが存在するかチェックを行う
   *
   * @return TRUE:存在する、FALSE:存在しない
   */
  public isExistImageIdInUseImageList(imageId: string): boolean {
    for (let i = Number(0); i < this.useImageList.length; i++) {
      if (this.useImageList[i].ImageId === imageId) {
        return true;
      }
    }
    return false;
  }

  /**
   * コンテキストメニューの活性化・非活性化処理を行う
   */
  public updateContextMenuEnabled(): void {
    // コンテキストメニューの活性化・非活性化処理を行う
    // 使用画像
    if (this.kymw5002Component.useImageMenu != null) {
      let enabledFlg = Boolean(true);
      const selectedIndex = this.getSelectedImageIndex(this.useImageList);
      if (!this.editMode || selectedIndex < 0) {
        enabledFlg = false;
      }
      this.kymw5002Component.useImageMenu.itemsSource[0].disabled = !enabledFlg;
      this.kymw5002Component.useImageMenu.itemsSource[2].disabled = !enabledFlg;
      this.kymw5002Component.useImageMenu.itemsSource[3].disabled = !enabledFlg;
      this.kymw5002Component.useImageMenu.itemsSource[4].disabled = !enabledFlg;
      this.kymw5002Component.useImageMenu.itemsSource[5].disabled = !enabledFlg;

      // 前へ・先頭へ
      if (selectedIndex === 0) {
        this.kymw5002Component.useImageMenu.itemsSource[2].disabled = true;
        this.kymw5002Component.useImageMenu.itemsSource[4].disabled = true;
      }
      // 後ろへ・最後へ
      if (selectedIndex === this.useImageList.length - 1) {
        this.kymw5002Component.useImageMenu.itemsSource[3].disabled = true;
        this.kymw5002Component.useImageMenu.itemsSource[5].disabled = true;
      }
      // 画像作成指示へ
      if (this.useImageList.length > 98) {
        this.kymw5002Component.useImageMenu.itemsSource[7].disabled = true;
      }
    }

    // 商品画像
    this.updateContextMenuCommonEnabled(this.goodsImageList, this.kymw5002Component.goodsImageMenu);

    // 使用履歴
    this.updateContextMenuCommonEnabled(this.useHistoryImageList, this.kymw5002Component.useHistoryMenu);

    // 検索画像
    this.updateContextMenuCommonEnabled(this.searchImageList, this.kymw5002Component.searchImageMenu);
  }

  /**
   * 共通コンテキストメニュー活性・非活性制御を行う
   */
  public updateContextMenuCommonEnabled(imageList: Array<any>, contextMenu: Menu): void {
    const selectedIndex = this.getSelectedImageIndex(imageList);
    if (selectedIndex < 0) {
      return;
    }

    // コンテキストメニュー活性化処理
    let useEnabledFlg = Boolean(false);
    if (this.editMode && this.useImageList.length < 99) {
      useEnabledFlg = true;
    }

    contextMenu.itemsSource[0].disabled = !useEnabledFlg;
  }

  public updateHeaderInfo(): void {
    this.pcode = this.inputPcode;
    this.guideGoodsName = this.inputGoodsName;
    this.guideStandardName = this.inputGoodsStandardName;
  }

  /**
   * 親画面に通知する
   */
  public refreshParent(): void {
    // this.viewHeler.refreshParent();
  }

  /**
   * 'コード：名称'の文字列を取得する
   */
  private getCodeValueName(code: string, name: string): string {
    let codeValueName = String('');
    if (!PlessViewUtilsSub.isEmpty(code) && !PlessViewUtilsSub.isEmpty(name)) {
      codeValueName = code + ':' + name;
    } else {
      codeValueName = code + name;
    }
    return codeValueName;
  }
}
